import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from "@material-ui/core/Button";
import MaterialTable from 'material-table';
import CircularProgress from '@material-ui/core/CircularProgress';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export class DefinitionsBeneficiariesPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            beneficiarieslist: [],

            beneficiariesNameCreate: "",

            beneficiariesTypeIdUpdate: "",
            beneficiariesNameUpdate: "",
            isBeneficiaryActive: -1,

            loading: true,
            notAuthorized: true,

            isFetching: false,
        }

        this.refUserUpdate = React.createRef();
    }

    componentDidMount() {
        this.loadBeneficiaries();
    }

    handleChange = async (e) => {
        //console.log(e);
        //console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeTitleCase = async (e) => {
        //console.log(e);
        //console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({
            [e.target.name]: e.target.value
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
        });
    };

    handleChangeIntegerOnly = async (e) => {
        //console.log(e);
        //console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value.replace(/\D/, '') });
    };

    handleChangePhone = async (e) => {
        //console.log(e);
        //console.log(e.target.name + " " + e.target.value);
        e.persist();

        if (e.target.value.length <= 14) {
            await this.setState({ [e.target.name]: e.target.value.replace(/\D/, '') });
        }
    };

    handleChangeDate = (name, value) => {
        //console.log(name);
        //console.log(value);

        this.setState({ [name]: new Date(value) });
    };

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    loadBeneficiaries = async () => {

        await fetch(global.variables.API_DEFINITIONS_GETLISTOFBENEFICIARIES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({
                        loading: false,
                        notAuthorized: true
                    });
                } else {
                    this.setState({
                        beneficiarieslist: result.listofbeneficiaries,
                        loading: false,
                        notAuthorized: false
                    });
                }
            });
    };

    createBeneficiary = async () => {

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_DEFINITIONS_CREATEBENEFICIARY, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed! " + result.errormessage, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadBeneficiaries();
            });

        await this.setState({ isFetching: false });
    };

    updateBeneficiary = async () => {

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_DEFINITIONS_UPDATEBENEFICIARY, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed! " + result.errormessage, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadBeneficiaries();
            });

        await this.setState({ isFetching: false });
    };

    handleSetUpdateFields = (beneficiaryId) => {

        //console.log(this.state);

        for (var i = 0; i < this.state.beneficiarieslist.length; i++) {
            if (this.state.beneficiarieslist[i].TypeId === beneficiaryId) {
                this.setState({
                    beneficiariesTypeIdUpdate: beneficiaryId,
                    beneficiariesNameUpdate: this.state.beneficiarieslist[i].TypeName,
                    isBeneficiaryActive: this.state.beneficiarieslist[i].isActive
                });

                window.scrollTo(0, this.refUserUpdate.current.offsetTop);
            }
        }


    }

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId === element) {
                return array[i];
            }
        }
        return ({ TypeId: "", TypeName: "" });
    };

    render() {

        //var userPermissionOptions = [
        //    { TypeId: 1, TypeName: "Administrator" },
        //    { TypeId: 2, TypeName: "Contractor" },
        //    { TypeId: 3, TypeName: "ROMIS User (Expert, QC, QA)" }
        //];

        var userStatusOptions = [
            { TypeId: 0, TypeName: "Active" },
            { TypeId: 1, TypeName: "Inactive" }
        ];

        const {
            //beneficiarieslist,

            beneficiariesNameCreate,

            //beneficiariesTypeIdUpdate,
            beneficiariesNameUpdate,
            isBeneficiaryActive,

            //loading,
            //notAuthorized,

            isFetching

        } = this.state;

        if (this.state.loading) {
            return (
                <Grid container spacing={3} >
                    <Grid item xs={12} className="mt-2" style={{ textAlign: "center", display: this.state.loading ? "block" : "none" }}>
                        <CircularProgress /> Loading...
                    </Grid>
                </Grid>
            );
        } else if (this.state.notAuthorized) {
            return (
                <p>You are not authorized</p>
            );
        } else {
            return (
                <Grid container spacing={3} >
                    <Grid>
                        <ToastContainer />
                    </Grid>
                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="New Beneficiary List Item" className='romis-card-header' />
                            <CardContent>
                                <TextField
                                    label="Name : *"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={beneficiariesNameCreate}
                                    name="beneficiariesNameCreate"
                                />
                                {
                                    //<TextField
                                    //    label="Surname : *"
                                    //    placeholder="Surname"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChangeTitleCase}
                                    //    value={usersSurnameCreate}
                                    //    name="usersSurnameCreate"
                                    ///>
                                    //<TextField
                                    //    label="Email : *"
                                    //    placeholder="Email"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={usersEmailCreate}
                                    //    name="usersEmailCreate"
                                    ///>
                                    //<TextField
                                    //    label="Telephone Number :"
                                    //    placeholder="Phone"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChangePhone}
                                    //    value={usersPhoneCreate}
                                    //    name="usersPhoneCreate"
                                    ///>
                                    //<TextField
                                    //    label="Institution :"
                                    //    placeholder="Institution"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={usersInstitutionCreate}
                                    //    name="usersInstitutionCreate"
                                    ///>
                                }
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} height="100%">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.createBeneficiary}
                            disabled={isFetching ? true : false}
                            fullWidth
                        >
                            Create New Beneficiary
                    </Button>
                    </Grid>

                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="Update Beneficiary List Item" className='romis-card-header' />
                            <CardContent>

                                <MaterialTable
                                    columns={[
                                        { title: 'User Id', field: 'TypeId', hidden: true },
                                        { title: 'Name', field: 'TypeName' }
                                    ]}
                                    data={this.state.beneficiarieslist}
                                    title="Beneficiaries"
                                    actions={[
                                        //{
                                        //    icon: 'info',
                                        //    tooltip: 'Project Details',
                                        //    onClick: (event, rowData) => {
                                        //        this.props.history.push(`/projectdetails/${rowData.idProjectDetails}`);
                                        //    },
                                        //},
                                        {
                                            icon: 'info',
                                            tooltip: 'Edit Beneficiary',
                                            onClick: (event, rowData) => {
                                                //this.props.history.push(`/missiondetails/${rowData.idMissionDetails}`);
                                                //this.setState({ selecteduserid: `${rowData.idContactListUsers}` });
                                                this.handleSetUpdateFields(`${rowData.TypeId}`);
                                            },
                                        },
                                    ]}
                                    options={{
                                        actionsColumnIndex: -1
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    {
                        //<Grid item xs={12} height="100%">
                        //    <Button
                        //        href={"/api/ReportGenerator/ExportContactListUsers/" + btoa(localStorage.getItem("authtoken"))}
                        //        variant="contained"
                        //        color="primary"
                        //        //onClick={this.updateUser}
                        //        disabled={isFetching ? true : false}
                        //        fullWidth
                        //    >
                        //        Download All Contacts as Excel
                        //</Button>
                        //</Grid>
                    }

                    <Grid item xs={12} height="100%" ref={this.refUserUpdate}>
                        <Card>
                            <CardHeader title="Beneficiary List Item Details" className='romis-card-header' />
                            <CardContent>
                                <TextField
                                    label="Name : *"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={beneficiariesNameUpdate}
                                    name="beneficiariesNameUpdate"
                                />
                                {
                                    //<Autocomplete
                                    //    options={userStatusOptions}
                                    //    getOptionLabel={option => option.TypeName}
                                    //    autoComplete
                                    //    includeInputInList
                                    //    onChange={(e, v) => { this.handleSelectChange(e, v, "isBeneficiaryActive") }}
                                    //    value={this.returnArrayElement(userStatusOptions, isBeneficiaryActive)}
                                    //    renderInput={params => (
                                    //        <TextField {...params} label="Status *" margin="normal" fullWidth />
                                    //    )}
                                    ///>
                                }
                                {
                                    //<TextField
                                    //    label="Status : *"
                                    //    placeholder="Surname"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChangeTitleCase}
                                    //    value={usersSurnameUpdate}
                                    //    name="usersSurnameUpdate"
                                    ///>
                                    //<TextField
                                    //    label="Email : *"
                                    //    placeholder="Email"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={usersEmailUpdate}
                                    //    name="usersEmailUpdate"
                                    ///>
                                    //<TextField
                                    //    label="Phone :"
                                    //    placeholder="Phone"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChangePhone}
                                    //    value={usersPhoneUpdate}
                                    //    name="usersPhoneUpdate"
                                    ///>
                                    //<TextField
                                    //    label="Institution :"
                                    //    placeholder="Institution"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={usersInstitutionUpdate}
                                    //    name="usersInstitutionUpdate"
                                    ///>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} height="100%">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.updateBeneficiary}
                            disabled={isFetching ? true : false}
                            fullWidth
                        >
                            Update Beneficiary
                        </Button>
                    </Grid>
                </Grid >
            );
        }
    }
}





// WEBPACK FOOTER //
// ./src/pages/DefinitionsBeneficiariesPage.js